import {isByteapp, isWeapp, omitUndefined} from "@firefly/fly-defter";
import { navigateToWeapp, WeappSDK } from './weapp';
import { ByteappSDK, navigateToByteapp } from './byteapp';
import { NavigationOptions } from './typing';

function params2query(params: Record<string, any>) {
  return new URLSearchParams(omitUndefined(params)).toString();
}
export function navigateToMiniapp(
  path: string,
  params: Record<string, any>,
  options: NavigationOptions = {},
) {
  const query = params2query(params);
  const miniappUrl = `${path}${query ? `?` + query : ''}`;
  if (isWeapp()) {
    return navigateToWeapp(miniappUrl, options);
  }
  if (isByteapp()) {
    return navigateToByteapp(miniappUrl, options);
  }
  return Promise.reject('current agent not miniapp');
}

export function relaunchMiniapp(path: string, params: Record<string, any>) {
  const query = params2query(params);
  const miniappUrl = `${path}${query ? `?` + query : ''}`;
  if (isWeapp()) {
    return WeappSDK.reLaunch(miniappUrl);
  }
  if (isByteapp()) {
    return ByteappSDK.redirectTo(miniappUrl);
  }
  return Promise.reject('current agent not miniapp');
}

export function navigateBackMiniapp() {
  if (isWeapp()) {
    return WeappSDK.navigateBack();
  }
  if (isByteapp()) {
    return ByteappSDK.navigateBack();
  }
  return Promise.reject('current agent not miniapp');
}
